/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: NDLA
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ShareBoxLine = (props: Props): JSX.Element => (
  <Icon fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M7 3v2H2v11h11v-5h2v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm11-3v8h-2V3.41l-7.8 7.8-1.4-1.42L14.57 2H10V0z"
    />
  </Icon>
);
